// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"0970e7d1","703":"6c2491a2","787":"34a20539"}[chunkId] + ".chunk.js";
};